import React, { useState, useEffect } from 'react';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import CheckCircleOutlineOutlinedIcon from '@material-ui/icons/CheckCircleOutlineOutlined';
import ThumbUpIcon from '@material-ui/icons/ThumbUp';
 
   
 
const AllPercComp = ({allPerc, getNum, dispatch}) => {
    const[percVal, setPV]  = useState(null)
    const[mesg, setMg]  = useState('')
    const[icon, setIcon]  = useState('')

     useEffect(() => {

      })   

 
     
    useEffect(() => {
        
        const percValidator = val => {
            let i = val
             if( i < 0) {
               i = 'wrong'
           }
           
           switch (i) {
               case 0: 
               setIcon( <CheckCircleOutlineOutlinedIcon style={{ fontSize: 'normal', verticalAlign: 'sub', color:'green'}}  /> );
                
                return setMg('  Hurray!! completed')
              
               case 'wrong': 
                setIcon( <ErrorOutlineIcon style={{ fontSize: 'normal', verticalAlign: 'sub', color:'#F08080'}}  /> );
              
                return  setMg(' - Exceeded limit of 100%')
                  
                 case 'none': 
                setIcon(''); return setMg('')   

                 case 'Duplicate': 
                  setIcon( <ErrorOutlineIcon style={{ fontSize: 'normal', verticalAlign: 'sub', color:'#F08080'}}  /> );
              
                 return  setMg(' - Item just entered already exists')          
           
               default: setIcon( <ThumbUpIcon style={{ fontSize: 'normal', verticalAlign: 'sub', color:'green'}}  /> );
               
               return setMg(' - great job add more')
                   
           }
       }
   
   
       if(allPerc.length > 0) {
        let mStatePec = allPerc.map(s => s.rPerc)
        let mS = mStatePec.reduce((prev, curr) => prev + curr)
        let sPerc = Number(Number(100 - mS ).toFixed(2))
                setPV(sPerc)
                percValidator(sPerc)
                getNum({num: sPerc, msg: mesg})


        let lastItem = allPerc.slice(-1)[0].budg // budg prop of the last object in the arr
  
        let valArr =  allPerc.filter(s => s.budg === lastItem)

         if( valArr.length > 1 ) {
            percValidator('Duplicate')
        }
        
      }
      else{ 
          setPV(null)
          percValidator('none')
          getNum({num: false, msg: mesg})
       }
    },[allPerc, getNum, mesg])

          
       return ( 
           <>
    <h3 style={{textAlign: 'center'}}>
    <span 
    style={{background:'silver', padding:'.5rem', borderRadius:'1rem' ,marginLeft:'1rem', cursor:'pointer'}}>
   
     <span style = {percVal <= 0 ? {display:'none'} : {display:'inline'}}> {percVal}% left </span>   
   
   <span style={mesg.includes('longer' || 'negative') ? {color:'red'} : {color:'black'} }>
           {icon} {mesg}
   </span>  
   
    </span>
     </h3>
   
           </>
        );
   }
   
 
export default AllPercComp;